import { useState } from "react";
import api from "../../services/api";
import { getRegionNameFromEnvVariables } from "../../services/helpers";
import { WAVE_URL, NOW_READY_URL } from "../GenerateAppUrlComponents/constants";

const NOWREADY_DEMO_URL = process.env.NOWREADY_DEMO_URL;
const NOWREADY_DEMO_REGION = process.env.NOWREADY_DEMO_REGION;
const DEV_ENVIRONMENT = process.env.NODE_ENV;

export const useAppUrlGenerator = (projectId, destinationId, generateUrlType) => {
    const [appUrl, setAppUrl] = useState(null);
    const [generatingUrl, setGeneratingUrl] = useState(false);

    const isGenerateUrlButtonDisabled = () => {
        return Boolean(generatingUrl || !projectId || !destinationId);
    };

    const nowReadyUrl = async () => {
        const idToken = localStorage.getItem("idToken");
        if(!generatingUrl) {
            setGeneratingUrl(true);
            try{
                const hsCode = await api.generateHelloScreensUrlCode(idToken, destinationId, projectId);
                const URL = `${NOWREADY_DEMO_URL}/?projectId=${projectId}&region=${NOWREADY_DEMO_REGION}&destinationId=${encodeURIComponent(destinationId)}&hsCode=${hsCode}`;
                setAppUrl(URL);
            } catch(error) {
                console.error('error', error);
            };
            setGeneratingUrl(false);
        };
    };

    const waveUrl = () => {
        const baseDevUrl = "https://wave-demo-dev-1.dev-bluedot.com";
        const baseUrl = "https://wave-demo.bluedot.io";
        if(!generatingUrl) {
            if (DEV_ENVIRONMENT === "dev") {
                const devURL = encodeURI(`${baseDevUrl}?projectId=${projectId}&destinationId=${destinationId}&region=DEV`);
                setAppUrl(devURL);
                return;
            } else {
                const region = getRegionNameFromEnvVariables({ useShorthand: true });
                const URL = encodeURI(`${baseUrl}?projectId=${projectId}&destinationId=${destinationId}&region=${region}`);
                setAppUrl(URL);
            };
        };
    };

    let generateUrl;
    switch (generateUrlType) {
        case NOW_READY_URL:
            generateUrl = () => nowReadyUrl();
            break;
        case WAVE_URL:
            generateUrl = () => waveUrl();
            break;
        default:
            break;
    };

    return {
        appUrl,
        setAppUrl,
        isGenerateUrlButtonDisabled,
        generateUrl
    };
};